import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import style from "../components/watIsWeefMobile.module.scss"
import Fig from "./Fig"

function createMarkup(tekst) {
  return { __html: tekst }
}

export default function GeschiedenisMobile() {
  const data = useStaticQuery(
    graphql`
      query MyMobileGeschiedenis {
        tekstJson {
          pagina {
            geschiedenis {
              body
              kop
            }
          }
        }
        touw: file(relativePath: { eq: "touw.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1000, maxHeight: 1500, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  return (
    <div className={style.wrapper} id="geschiedenis">
      <div className={style.tekst}>
        <h2>{data.tekstJson.pagina.geschiedenis.kop}</h2>
        <p
          dangerouslySetInnerHTML={createMarkup(
            data.tekstJson.pagina.geschiedenis.body
          )}
        />
      </div>
      <div className={style.fotos}>
        <Fig
          image={data.touw.childImageSharp.fluid}
          caption="In Amersfoort gewonnen zijde</br>Museum Flehite"
          stylo={{ height: "100%" }}
          imgStylo={{ scale: "1.4" }}
        ></Fig>
      </div>
    </div>
  )
}
